import React from "react";
import { Outlet } from "react-router-dom";

import { Col, Container, Row } from "react-bootstrap";

import Main from "../components/Main";

// layout before login
const Auth = ({ children }) => {

  return (
    <React.Fragment>
      <Main className="d-flex w-100 justify-content-center auth-layout">
        <Container className="d-flex flex-column">
          <Row className="h-100">
            <Col lg="8" className="mx-auto d-table h-100">
              <div className="d-table-cell align-middle">
                {children}
                <Outlet />
              </div>
            </Col>
          </Row>
        </Container>
      </Main>
    </React.Fragment>
  );
};

export default Auth;
